// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3uzcx","inputWrap":"Table_inputWrap__3qyDx","col":"Table_col__H9h3A","bmiTooltip":"Table_bmiTooltip__t-k9Y"};